const Loading: React.FC = (props) => {
  return (
    <>Loading...</>
  )
}

export default Loading
